/* eslint-disable import/prefer-default-export */
import { graphql, useStaticQuery } from 'gatsby'

export const useTreatmentCategories = () => {
  const data = useStaticQuery(graphql`
    query TreatmentCategoriesQuery {
      allWpPage(
        filter: { filterargument: { filterargument: { eq: "categories" } } }
      ) {
        nodes {
          id
          pageType {
            taxonomy
          }
          title
          language {
            slug
          }
          filterargument {
            filterargument
          }
          treatmentcategorycontent {
            treatmentcategory1 {
              content
              heading
              includeinmenu
              isundercategory
              treatments {
                nodes {
                  ... on WpPage {
                    id
                    slug
                    title
                    pageType {
                      uri
                      name
                    }
                    treatmentpricingsection {
                      treatmentpricecard1 {
                        pricecardkicker
                        pricecardprice
                        pricecardtitle
                      }
                      treatmentpricecard2 {
                        pricecardkicker
                        pricecardprice
                        pricecardtitle
                      }
                      treatmentpricecard3 {
                        pricecardkicker
                        pricecardprice
                        pricecardtitle
                      }
                      treatmentpricecard4 {
                        pricecardkicker
                        pricecardprice
                        pricecardtitle
                      }
                      treatmentpricecard5 {
                        pricecardkicker
                        pricecardprice
                        pricecardtitle
                      }
                      treatmentpricecard6 {
                        pricecardkicker
                        pricecardprice
                        pricecardtitle
                      }
                      treatmentpricecard7 {
                        pricecardkicker
                        pricecardprice
                        pricecardtitle
                      }
                      treatmentpricecard8 {
                        pricecardkicker
                        pricecardprice
                        pricecardtitle
                      }
                    }
                  }
                }
              }
              image {
                node {
                  altText
                  sourceUrl
                  localFile {
                    childImageSharp {
                      gatsbyImageData(
                        quality: 80
                        webpOptions: { quality: 80 }
                        avifOptions: { lossless: true, quality: 80 }
                      )
                    }
                  }
                  mediaItemUrl
                  mediaType
                }
              }
            }
            treatmentcategory2 {
              content
              heading
              includeinmenu
              isundercategory
              treatments {
                nodes {
                  ... on WpPage {
                    id
                    slug
                    title
                    pageType {
                      uri
                      name
                    }
                    treatmentpricingsection {
                      treatmentpricecard1 {
                        pricecardkicker
                        pricecardprice
                        pricecardtitle
                      }
                      treatmentpricecard2 {
                        pricecardkicker
                        pricecardprice
                        pricecardtitle
                      }
                      treatmentpricecard3 {
                        pricecardkicker
                        pricecardprice
                        pricecardtitle
                      }
                      treatmentpricecard4 {
                        pricecardkicker
                        pricecardprice
                        pricecardtitle
                      }
                      treatmentpricecard5 {
                        pricecardkicker
                        pricecardprice
                        pricecardtitle
                      }
                      treatmentpricecard6 {
                        pricecardkicker
                        pricecardprice
                        pricecardtitle
                      }
                      treatmentpricecard7 {
                        pricecardkicker
                        pricecardprice
                        pricecardtitle
                      }
                      treatmentpricecard8 {
                        pricecardkicker
                        pricecardprice
                        pricecardtitle
                      }
                    }
                  }
                }
              }
              image {
                node {
                  altText
                  sourceUrl
                  localFile {
                    childImageSharp {
                      gatsbyImageData(
                        quality: 80
                        webpOptions: { quality: 80 }
                        avifOptions: { lossless: true, quality: 80 }
                      )
                    }
                  }
                  mediaItemUrl
                  mediaType
                }
              }
            }
            treatmentcategory3 {
              content
              heading
              includeinmenu
              isundercategory
              treatments {
                nodes {
                  ... on WpPage {
                    id
                    slug
                    title
                    pageType {
                      uri
                      name
                    }
                    treatmentpricingsection {
                      treatmentpricecard1 {
                        pricecardkicker
                        pricecardprice
                        pricecardtitle
                      }
                      treatmentpricecard2 {
                        pricecardkicker
                        pricecardprice
                        pricecardtitle
                      }
                      treatmentpricecard3 {
                        pricecardkicker
                        pricecardprice
                        pricecardtitle
                      }
                      treatmentpricecard4 {
                        pricecardkicker
                        pricecardprice
                        pricecardtitle
                      }
                      treatmentpricecard5 {
                        pricecardkicker
                        pricecardprice
                        pricecardtitle
                      }
                      treatmentpricecard6 {
                        pricecardkicker
                        pricecardprice
                        pricecardtitle
                      }
                      treatmentpricecard7 {
                        pricecardkicker
                        pricecardprice
                        pricecardtitle
                      }
                      treatmentpricecard8 {
                        pricecardkicker
                        pricecardprice
                        pricecardtitle
                      }
                    }
                  }
                }
              }
              image {
                node {
                  altText
                  sourceUrl
                  localFile {
                    childImageSharp {
                      gatsbyImageData(
                        quality: 80
                        webpOptions: { quality: 80 }
                        avifOptions: { lossless: true, quality: 80 }
                      )
                    }
                  }
                  mediaItemUrl
                  mediaType
                }
              }
            }
            treatmentcategory4 {
              content
              heading
              includeinmenu
              isundercategory
              treatments {
                nodes {
                  ... on WpPage {
                    id
                    slug
                    title
                    pageType {
                      uri
                      name
                    }
                    treatmentpricingsection {
                      treatmentpricecard1 {
                        pricecardkicker
                        pricecardprice
                        pricecardtitle
                      }
                      treatmentpricecard2 {
                        pricecardkicker
                        pricecardprice
                        pricecardtitle
                      }
                      treatmentpricecard3 {
                        pricecardkicker
                        pricecardprice
                        pricecardtitle
                      }
                      treatmentpricecard4 {
                        pricecardkicker
                        pricecardprice
                        pricecardtitle
                      }
                      treatmentpricecard5 {
                        pricecardkicker
                        pricecardprice
                        pricecardtitle
                      }
                      treatmentpricecard6 {
                        pricecardkicker
                        pricecardprice
                        pricecardtitle
                      }
                      treatmentpricecard7 {
                        pricecardkicker
                        pricecardprice
                        pricecardtitle
                      }
                      treatmentpricecard8 {
                        pricecardkicker
                        pricecardprice
                        pricecardtitle
                      }
                    }
                  }
                }
              }
              image {
                node {
                  altText
                  sourceUrl
                  localFile {
                    childImageSharp {
                      gatsbyImageData(
                        quality: 80
                        webpOptions: { quality: 80 }
                        avifOptions: { lossless: true, quality: 80 }
                      )
                    }
                  }
                  mediaItemUrl
                  mediaType
                }
              }
            }
            treatmentcategory5 {
              content
              heading
              includeinmenu
              isundercategory
              treatments {
                nodes {
                  ... on WpPage {
                    id
                    slug
                    title
                    pageType {
                      uri
                      name
                    }
                    treatmentpricingsection {
                      treatmentpricecard1 {
                        pricecardkicker
                        pricecardprice
                        pricecardtitle
                      }
                      treatmentpricecard2 {
                        pricecardkicker
                        pricecardprice
                        pricecardtitle
                      }
                      treatmentpricecard3 {
                        pricecardkicker
                        pricecardprice
                        pricecardtitle
                      }
                      treatmentpricecard4 {
                        pricecardkicker
                        pricecardprice
                        pricecardtitle
                      }
                      treatmentpricecard5 {
                        pricecardkicker
                        pricecardprice
                        pricecardtitle
                      }
                      treatmentpricecard6 {
                        pricecardkicker
                        pricecardprice
                        pricecardtitle
                      }
                      treatmentpricecard7 {
                        pricecardkicker
                        pricecardprice
                        pricecardtitle
                      }
                      treatmentpricecard8 {
                        pricecardkicker
                        pricecardprice
                        pricecardtitle
                      }
                    }
                  }
                }
              }
              image {
                node {
                  altText
                  sourceUrl
                  localFile {
                    childImageSharp {
                      gatsbyImageData(
                        quality: 80
                        webpOptions: { quality: 80 }
                        avifOptions: { lossless: true, quality: 80 }
                      )
                    }
                  }
                  mediaItemUrl
                  mediaType
                }
              }
            }
            treatmentcategory6 {
              content
              heading
              includeinmenu
              isundercategory
              treatments {
                nodes {
                  ... on WpPage {
                    id
                    slug
                    title
                    pageType {
                      uri
                      name
                    }
                    treatmentpricingsection {
                      treatmentpricecard1 {
                        pricecardkicker
                        pricecardprice
                        pricecardtitle
                      }
                      treatmentpricecard2 {
                        pricecardkicker
                        pricecardprice
                        pricecardtitle
                      }
                      treatmentpricecard3 {
                        pricecardkicker
                        pricecardprice
                        pricecardtitle
                      }
                      treatmentpricecard4 {
                        pricecardkicker
                        pricecardprice
                        pricecardtitle
                      }
                      treatmentpricecard5 {
                        pricecardkicker
                        pricecardprice
                        pricecardtitle
                      }
                      treatmentpricecard6 {
                        pricecardkicker
                        pricecardprice
                        pricecardtitle
                      }
                      treatmentpricecard7 {
                        pricecardkicker
                        pricecardprice
                        pricecardtitle
                      }
                      treatmentpricecard8 {
                        pricecardkicker
                        pricecardprice
                        pricecardtitle
                      }
                    }
                  }
                }
              }
              image {
                node {
                  altText
                  sourceUrl
                  localFile {
                    childImageSharp {
                      gatsbyImageData(
                        quality: 80
                        webpOptions: { quality: 80 }
                        avifOptions: { lossless: true, quality: 80 }
                      )
                    }
                  }
                  mediaItemUrl
                  mediaType
                }
              }
            }
            treatmentcategory7 {
              content
              heading
              includeinmenu
              isundercategory
              treatments {
                nodes {
                  ... on WpPage {
                    id
                    slug
                    title
                    pageType {
                      uri
                      name
                    }
                    treatmentpricingsection {
                      treatmentpricecard1 {
                        pricecardkicker
                        pricecardprice
                        pricecardtitle
                      }
                      treatmentpricecard2 {
                        pricecardkicker
                        pricecardprice
                        pricecardtitle
                      }
                      treatmentpricecard3 {
                        pricecardkicker
                        pricecardprice
                        pricecardtitle
                      }
                      treatmentpricecard4 {
                        pricecardkicker
                        pricecardprice
                        pricecardtitle
                      }
                      treatmentpricecard5 {
                        pricecardkicker
                        pricecardprice
                        pricecardtitle
                      }
                      treatmentpricecard6 {
                        pricecardkicker
                        pricecardprice
                        pricecardtitle
                      }
                      treatmentpricecard7 {
                        pricecardkicker
                        pricecardprice
                        pricecardtitle
                      }
                      treatmentpricecard8 {
                        pricecardkicker
                        pricecardprice
                        pricecardtitle
                      }
                    }
                  }
                }
              }
              image {
                node {
                  altText
                  sourceUrl
                  localFile {
                    childImageSharp {
                      gatsbyImageData(
                        quality: 80
                        webpOptions: { quality: 80 }
                        avifOptions: { lossless: true, quality: 80 }
                      )
                    }
                  }
                  mediaItemUrl
                  mediaType
                }
              }
            }
            treatmentcategory8 {
              content
              heading
              includeinmenu
              isundercategory
              treatments {
                nodes {
                  ... on WpPage {
                    id
                    slug
                    title
                    pageType {
                      uri
                      name
                    }
                    treatmentpricingsection {
                      treatmentpricecard1 {
                        pricecardkicker
                        pricecardprice
                        pricecardtitle
                      }
                      treatmentpricecard2 {
                        pricecardkicker
                        pricecardprice
                        pricecardtitle
                      }
                      treatmentpricecard3 {
                        pricecardkicker
                        pricecardprice
                        pricecardtitle
                      }
                      treatmentpricecard4 {
                        pricecardkicker
                        pricecardprice
                        pricecardtitle
                      }
                      treatmentpricecard5 {
                        pricecardkicker
                        pricecardprice
                        pricecardtitle
                      }
                      treatmentpricecard6 {
                        pricecardkicker
                        pricecardprice
                        pricecardtitle
                      }
                      treatmentpricecard7 {
                        pricecardkicker
                        pricecardprice
                        pricecardtitle
                      }
                      treatmentpricecard8 {
                        pricecardkicker
                        pricecardprice
                        pricecardtitle
                      }
                    }
                  }
                }
              }
              image {
                node {
                  altText
                  sourceUrl
                  localFile {
                    childImageSharp {
                      gatsbyImageData(
                        quality: 80
                        webpOptions: { quality: 80 }
                        avifOptions: { lossless: true, quality: 80 }
                      )
                    }
                  }
                  mediaItemUrl
                  mediaType
                }
              }
            }
            treatmentcategory9 {
              content
              heading
              includeinmenu
              isundercategory
              treatments {
                nodes {
                  ... on WpPage {
                    id
                    slug
                    title
                    pageType {
                      uri
                      name
                    }
                    treatmentpricingsection {
                      treatmentpricecard1 {
                        pricecardkicker
                        pricecardprice
                        pricecardtitle
                      }
                      treatmentpricecard2 {
                        pricecardkicker
                        pricecardprice
                        pricecardtitle
                      }
                      treatmentpricecard3 {
                        pricecardkicker
                        pricecardprice
                        pricecardtitle
                      }
                      treatmentpricecard4 {
                        pricecardkicker
                        pricecardprice
                        pricecardtitle
                      }
                      treatmentpricecard5 {
                        pricecardkicker
                        pricecardprice
                        pricecardtitle
                      }
                      treatmentpricecard6 {
                        pricecardkicker
                        pricecardprice
                        pricecardtitle
                      }
                      treatmentpricecard7 {
                        pricecardkicker
                        pricecardprice
                        pricecardtitle
                      }
                      treatmentpricecard8 {
                        pricecardkicker
                        pricecardprice
                        pricecardtitle
                      }
                    }
                  }
                }
              }
              image {
                node {
                  altText
                  sourceUrl
                  localFile {
                    childImageSharp {
                      gatsbyImageData(
                        quality: 80
                        webpOptions: { quality: 80 }
                        avifOptions: { lossless: true, quality: 80 }
                      )
                    }
                  }
                  mediaItemUrl
                  mediaType
                }
              }
            }
            treatmentprimarydata {
              category1 {
                content
                maincategory
                title
                kicker
                image {
                  node {
                    altText
                    sourceUrl
                    localFile {
                      childImageSharp {
                        gatsbyImageData(
                          quality: 80
                          webpOptions: { quality: 80 }
                          avifOptions: { lossless: true, quality: 80 }
                        )
                      }
                    }
                    mediaItemUrl
                    mediaType
                  }
                }
              }
              category2 {
                content
                maincategory
                title
                kicker
                image {
                  node {
                    altText
                    sourceUrl
                    localFile {
                      childImageSharp {
                        gatsbyImageData(
                          quality: 80
                          webpOptions: { quality: 80 }
                          avifOptions: { lossless: true, quality: 80 }
                        )
                      }
                    }
                    mediaItemUrl
                    mediaType
                  }
                }
              }
              category3 {
                content
                maincategory
                title
                kicker
                image {
                  node {
                    altText
                    sourceUrl
                    localFile {
                      childImageSharp {
                        gatsbyImageData(
                          quality: 80
                          webpOptions: { quality: 80 }
                          avifOptions: { lossless: true, quality: 80 }
                        )
                      }
                    }
                    mediaItemUrl
                    mediaType
                  }
                }
              }
            }
          }
        }
      }
    }
  `)

  return data.allWpPage.nodes
}
